var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14920_1112)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14920_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.92898 4.92893C1.02575 8.83216 1.02575 15.1678 4.92898 19.0711C8.83221 22.9743 15.1679 22.9743 19.0711 19.0711C22.9743 15.1678 22.9743 8.83216 19.0711 4.92893C15.1679 1.0257 8.83221 1.0257 4.92898 4.92893ZM16.8891 7.81802C17.0844 8.01328 17.0844 8.32986 16.8891 8.52513L13.4143 12L16.8891 15.4749C17.0844 15.6701 17.0844 15.9867 16.8891 16.182L16.182 16.8891C15.9868 17.0843 15.6702 17.0843 15.4749 16.8891L12 13.4142L8.52517 16.8891C8.32991 17.0843 8.01333 17.0843 7.81807 16.8891L7.11096 16.182C6.9157 15.9867 6.9157 15.6701 7.11096 15.4749L10.5858 12L7.11096 8.52513C6.9157 8.32986 6.9157 8.01328 7.11096 7.81802L7.81807 7.11091C8.01333 6.91565 8.32991 6.91565 8.52517 7.11091L12 10.5858L15.4749 7.11091C15.6702 6.91565 15.9868 6.91565 16.182 7.11091L16.8891 7.81802Z",
    fill: "#ADBFDF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14920_1112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14920_1112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/iconCancel.7eb5cdf18428c9608c2013ffe6285ed1.svg";
export { ForwardRef as ReactComponent };